
import { EMPLOYEE_ADD_CONF, prefetchOrgRoles } from "./employeeAddConf";
import { EMPLOYEE_PAGE_OBJECT } from "./employeePageConf";
import { API_ROOT } from "../../supplementary_components/requests";
import { can } from "../../supplementary_components/userDataDelegate";
import { RolesManagement } from "./RolesManagement";

const ROOT_PATH = "/employees/"

// Function to format phone and extension
const combinePhoneWithExtension = (data) => {
  let result = (data["directLine"] || "-") + ' / ' + (data["extension"] || "-");
  return result;
};

// Function to format first and last names
const combineFullName = (data) => {
  let result = data["firstName"] + ' ' + data["lastName"];
  return result;
};

const toTitleCase = (name) => {
  if (!name) return "";
  return name
    .toLowerCase()
    .split(/\s+/)
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
    .join(" ");
};

const accessibleCompaniesCell = (data) => {
  const companies = data?.accessibleCompanies;
  if (!Array.isArray(companies) || companies.length === 0) {
    return <div key={"companies-" + data.id}>-</div>;
  }
  return (
    <div
      key={"companies-" + data.id}
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "0.3rem",
        alignItems: "center",
        minWidth: 0,
      }}
    >
      {companies.map((company) => {
        const displayName = toTitleCase(company.companyName);
        return (
          <span
            key={company.id}
            title={company.companyName}
            style={{
              display: "inline-block",
              maxWidth: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: "0.9em",
              lineHeight: 1.3,
              padding: "0.1rem 0.45rem",
              borderRadius: "0.35rem",
              border: "1px solid var(--medium-light-gray)",
              background: "var(--extra-lighter-gray)",
              color: "var(--dark-gray)",
            }}
          >
            {displayName}
          </span>
        );
      })}
    </div>
  );
};

export const EMPLOYEE_LISTING_CONF = {
    getRequestLink: API_ROOT+"employees",
    columnProportions: "12.5% 12.5% 25% 10% 10% 15% 15%",
    dataTitle: "Employee",
    dataTitlePlural:"Employees",
    addButton:true,
    addConf: EMPLOYEE_ADD_CONF,
    pageConf: new EMPLOYEE_PAGE_OBJECT(),
    category: 'employees',
    minAccessToItemPage: { key: 'USERS', level: 'VIEW' },
    processViewStructure: (viewStructure) => {
        const canViewUsers = can('USERS', 'VIEW');
        const canViewRoles = can('ROLES', 'VIEW');
        if (canViewUsers) {
            prefetchOrgRoles();
        }
        const next = { ...viewStructure };
        if (!canViewRoles) {
            delete next.categorizedList;
        } else if (!canViewUsers) {
            const rolesOption = viewStructure.categorizedList.options.find((option) => option.label === "Roles");
            next.categorizedList = {
                defaultOptionIndex: 0,
                options: [rolesOption],
            };
            next.skipListRequest = true;
            delete next.filtration;
        }
        return next;
    },
    categorizedList: {
        defaultOptionIndex: 0,
        options: [
            { label: "Employees" },
            {
                label: "Roles",
                noAddButton: true,
                categorySpecificComponent: RolesManagement,
            },
        ],
    },
    filtration: {
        filtrationLinkRoot: "employees/filtration",
        searchByFieldNames: [
            {
                valueLocation: ['firstName', 'lastName'],
                categoryLbl: "By Name",
                searchKey: "byName",
            },
            {
                valueLocation: ['firstName', 'lastName'],
                filtrationLbl: "name:",
                searchKey: "byName",
                hint: "Name",
            },
            {
                valueLocation: "roleName",
                filtrationLbl: "role:",
                searchKey: "byRole",
                hint: "Role",
            },
        ],
    },
    columns :[
        {
            label: "Full name",
            valueGenerator: combineFullName,
            columnName: "id",
            identifierColumnName: "id",
            sortable: true,
            clickable: true,
            path: ROOT_PATH,
        },
        {
            label: "Status",
            columnName: "active",
            sortable: true,
            clickable: false,
            path: null,
            conditionalFormatting: (value)=>{
                if(value)return null;
                return `& > * {color:white;
                        font-weight:600;
                        background:var(--alert-color);
                        padding: 0.1rem 0.9rem;
                        border-radius:1rem;}`

            },
            valueInterpreter: (value)=>{
                if(value)return "Active";
                return "Inactive"
            },
            alignment:"center",
        },
        {
            label: "Companies",
            customComponent: accessibleCompaniesCell,
        },
        {
            label: "Role",
            columnName: "roleName",
            alignment:"center",
            sortable: true,
        },
        
        {
            label: "Telegram",
            columnName: "telegramUserName",
            alignment:"center",
        },
        {
            label: "Email",
            columnName: "email",
            alignment:"center",
        },
        {
            label: "Direct number",
            valueGenerator: combinePhoneWithExtension,
            alignment:"center",
        }

    ]
}